import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const fetchProductDamFileList = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM_PRODUCT_FILE.FETCH_DAM_FILE_LIST}/${data.devOrderId}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteProductDamFiles = async (payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DAM_PRODUCT_FILE.DELETE_PRODUCT_DAM_FILES}/${payload?.devOrderId}`, {
      data: payload,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateProductFileInLibraryCollection = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM_PRODUCT_FILE.UPDATE_PRODUCT_FILES_TO_LIBRARY}/${payload.devOrderId}/${payload.fileId}`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const saveProductDamFiles = async (payload, devOrderId) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM_PRODUCT_FILE.ADD_PRODUCT_FILE}/${devOrderId}`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getDamProductRecordById = async (damId, devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM_PRODUCT_FILE.GET_PRODUCT_DAM_BY_ID}/${damId}/${devOrderId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateProductDamFiles = async (payload, devOrderId) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM_PRODUCT_FILE.UPDATE_PRODUCT_DAM_FILES}/${payload._id}/${devOrderId}`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchProductDamTag = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM_PRODUCT_FILE.FETCH_DAM_PRODUCT_TAGS_LIST}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchProductFolderOptionList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM_PRODUCT_FILE.FETCH_PRODUCT_FOLDER_OPTION_LIST}/${data?.devOrderId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const checkProductDamNameExist = async (payload, devOrderId) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM_PRODUCT_FILE.CHECK_DAM_NAME_EXIST}/${devOrderId}`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};
